import { encodeCode39 } from "./code39";

/** 前後留白（quiet zone），單位＝窄條寬；少了掃描器會抓不到起止碼 */
const QUIET = 10;

/**
 * Code 39 條碼（SVG），給客戶在超商櫃檯出示手機掃描。
 * 寬度撐滿容器、高度固定：手機螢幕上窄條要夠寬掃描器才讀得到，所以不縮成一行小字。
 * 白底寫死不跟主題變色——條碼一定要白底黑條。
 */
export default function Code39Barcode({ value }: { value: string }) {
  const { bars, width } = encodeCode39(value);
  const total = width + QUIET * 2;
  return (
    <div style={{ width: "100%", textAlign: "center", background: "#fff" }}>
      <svg
        width="100%"
        height={56}
        viewBox={`0 0 ${total} 40`}
        preserveAspectRatio="none"
        shapeRendering="crispEdges"
        role="img"
        aria-label={value}
        style={{ display: "block", background: "#fff" }}>
        {bars.map(({ x, w }) => (
          <rect key={x} x={x + QUIET} y={0} width={w} height={40} fill="#000" />
        ))}
      </svg>
      <div style={{ fontFamily: "monospace", fontSize: 13, letterSpacing: 1, color: "#111", marginTop: 4 }}>
        {value}
      </div>
    </div>
  );
}
